import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { initSentry } from "@/lib/sentry";
import { App } from "@/App";
import "@/styles/index.css";

// No-op in dev / preview without a DSN. See src/lib/sentry.ts to enable.
initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

// Initialise theme from localStorage (falls back to system).
const storedTheme = localStorage.getItem("neo-theme");
if (storedTheme === "dark" || storedTheme === "light") {
  document.body.classList.add(`theme-${storedTheme}`);
} else {
  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  document.body.classList.add(prefersDark ? "theme-dark" : "theme-light");
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
